import { FiMoreHorizontal } from "react-icons/fi";
import "./songDurationMenu.scss";

const SongDurationMenu = () => {
  return <FiMoreHorizontal className="song-duration-menu" />;
};

export default SongDurationMenu;
